export default "__VITE_ASSET__CEQFmFW3__"